import { toast } from 'react-toastify';

import { useMutation } from '@tanstack/react-query';
import { apiAdapter } from '../../config/adapters/api.adapter';
import { API_URLS } from '../../constants/api_links';

interface CreateLoanRequestPayload {
   userId: number;
   requestDate: Date;
   requestAmount: number;
   period: number;
   frequency: string;
   description: string | null;
   bankId: number;
   accountNumber: number;
   accountType: string;
}

export const useCreateLoanRequest = () => {
   return useMutation({
      mutationFn: async (payload: CreateLoanRequestPayload) => {
         return await apiAdapter.post(API_URLS.CREATE_LOAD_REQUEST, {
            user_id: payload.userId,
            request_date: payload.requestDate,
            requested_amount: payload.requestAmount,
            period: payload.period,
            frequency: payload.frequency,
            description: payload.description,
            bank_id: payload.bankId,
            account_number: payload.accountNumber,
            account_type: payload.accountType,
         });
      },
      onSuccess: () => {
         toast.success('Préstamo solicitado con éxito');
      },
      onError: () => {
         toast.error('Error al solicitar el préstamo');
      },
   });
};
